import { useState, useEffect, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const solutionsData = [
  {
    id: 1,
    category: "E-Commerce",
    title: "Complete E-Commerce Growth Solution",
    color: "from-blue-500 to-indigo-600",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
    ),
    description: "End-to-end digital marketing solution designed specifically for online stores to maximize sales and customer lifetime value.",
    challenges: [
      "Low conversion rates",
      "High cart abandonment",
      "Poor product visibility",
      "Limited customer retention"
    ],
    solutions: [
      "Conversion Rate Optimization (CRO)",
      "Shopping Ads Management",
      "Email Marketing Automation",
      "Retargeting Campaigns",
      "Product Feed Optimization",
      "Customer Segmentation"
    ],
    results: [
      "150% increase in online sales",
      "40% reduction in cart abandonment",
      "3x ROAS on ad spend",
      "60% boost in repeat purchases"
    ],
    industries: ["Fashion", "Electronics", "Home & Garden", "Beauty"],
    pricing: "Custom packages from $2,499/month"
  },
  {
    id: 2,
    category: "SaaS",
    title: "SaaS Growth & Acquisition Solution",
    color: "from-purple-500 to-pink-600",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
    ),
    description: "Comprehensive marketing strategy to drive qualified leads, reduce churn, and scale your SaaS business efficiently.",
    challenges: [
      "High customer acquisition cost",
      "Low trial-to-paid conversion",
      "Increasing churn rate",
      "Limited brand awareness"
    ],
    solutions: [
      "Content Marketing Strategy",
      "SEO & Organic Growth",
      "PPC Lead Generation",
      "Marketing Automation",
      "Onboarding Optimization",
      "Customer Success Programs"
    ],
    results: [
      "65% reduction in CAC",
      "45% increase in trial conversions",
      "30% decrease in churn rate",
      "200% growth in MRR"
    ],
    industries: ["B2B SaaS", "Productivity Tools", "Analytics", "CRM"],
    pricing: "Custom packages from $3,499/month"
  },
  {
    id: 3,
    category: "Local Business",
    title: "Local Business Domination Solution",
    color: "from-green-500 to-emerald-600",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    ),
    description: "Dominate your local market with targeted strategies that drive foot traffic, calls, and local customer engagement.",
    challenges: [
      "Low local visibility",
      "Inconsistent customer flow",
      "Negative online reviews",
      "Competition from chains"
    ],
    solutions: [
      "Local SEO Optimization",
      "Google Business Profile Management",
      "Local PPC Campaigns",
      "Reputation Management",
      "Social Media Marketing",
      "Local Content Creation"
    ],
    results: [
      "300% increase in local searches",
      "85% more phone calls",
      "4.8+ star average rating",
      "50% increase in foot traffic"
    ],
    industries: ["Restaurants", "Healthcare", "Home Services", "Retail"],
    pricing: "Packages from $899/month"
  },
  {
    id: 4,
    category: "B2B",
    title: "B2B Lead Generation Solution",
    color: "from-orange-500 to-red-600",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    ),
    description: "Generate high-quality B2B leads and build a predictable sales pipeline with our proven multi-channel approach.",
    challenges: [
      "Unqualified leads",
      "Long sales cycles",
      "Low engagement rates",
      "Poor lead nurturing"
    ],
    solutions: [
      "LinkedIn Lead Generation",
      "Account-Based Marketing",
      "Content Marketing",
      "Email Outreach Campaigns",
      "Webinar Marketing",
      "Lead Scoring & Nurturing"
    ],
    results: [
      "250% increase in qualified leads",
      "40% shorter sales cycle",
      "60% higher engagement rates",
      "5x ROI on marketing spend"
    ],
    industries: ["Technology", "Manufacturing", "Professional Services", "Finance"],
    pricing: "Custom packages from $2,999/month"
  },
  {
    id: 5,
    category: "Startup",
    title: "Startup Launch & Scale Solution",
    color: "from-cyan-500 to-blue-600",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
    ),
    description: "Launch your startup with maximum impact and scale efficiently with data-driven marketing strategies on a lean budget.",
    challenges: [
      "Limited marketing budget",
      "No brand awareness",
      "Unclear target audience",
      "Need for rapid growth"
    ],
    solutions: [
      "Brand Strategy & Positioning",
      "Growth Hacking Tactics",
      "Lean Marketing Approach",
      "Product-Market Fit Testing",
      "Viral Marketing Campaigns",
      "Community Building"
    ],
    results: [
      "10,000+ users in first 3 months",
      "80% organic growth rate",
      "Featured in major publications",
      "Successful funding rounds"
    ],
    industries: ["Tech Startups", "Mobile Apps", "Fintech", "Healthtech"],
    pricing: "Packages from $1,499/month"
  },
  {
    id: 6,
    category: "Enterprise",
    title: "Enterprise Digital Transformation",
    color: "from-violet-500 to-purple-600",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
    ),
    description: "Transform your enterprise marketing with AI-powered solutions, advanced analytics, and scalable multi-channel strategies.",
    challenges: [
      "Siloed marketing efforts",
      "Legacy systems",
      "Complex customer journeys",
      "Need for scalability"
    ],
    solutions: [
      "Marketing Automation Platform",
      "AI-Powered Personalization",
      "Advanced Analytics & BI",
      "Omnichannel Strategy",
      "Marketing Operations",
      "Team Training & Support"
    ],
    results: [
      "40% increase in marketing efficiency",
      "Unified customer view across channels",
      "25% reduction in marketing costs",
      "Data-driven decision making"
    ],
    industries: ["Fortune 500", "Healthcare", "Financial Services", "Retail Chains"],
    pricing: "Custom enterprise packages from $10,000/month"
  }
];

const SolutionsPage = () => {
  const [selectedSolution, setSelectedSolution] = useState(null);
  const [activeCategory, setActiveCategory] = useState("All");
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const categories = ["All", ...new Set(solutionsData.map(s => s.category))];

  const filteredSolutions = activeCategory === "All" 
    ? solutionsData 
    : solutionsData.filter(s => s.category === activeCategory);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-indigo-50">
      <Navbar />
      
      {/* Hero Section */}
      <div className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-indigo-100 border border-indigo-200 mb-6">
            <span className="w-2 h-2 bg-indigo-600 rounded-full mr-2 animate-pulse"></span>
            <span className="text-sm font-medium text-indigo-700 uppercase tracking-wider">
              Industry Solutions
            </span>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-gray-900 to-indigo-900 bg-clip-text text-transparent mb-6">
            Tailored Solutions for
          </h1>
          <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent mb-8">
            Every Business Challenge
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Industry-specific marketing solutions designed to solve your unique challenges 
            and drive measurable results for your business.
          </p>
        </div>
      </div>

      {/* Category Filter */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <div className="flex flex-wrap justify-center gap-3">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-6 py-3 rounded-xl font-medium transition-all duration-300 transform hover:scale-105 ${
                activeCategory === category
                  ? "bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg"
                  : "bg-white text-gray-600 hover:bg-gray-50 border border-gray-200"
              }`}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      {/* Solutions Grid */}
      <div ref={sectionRef} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredSolutions.map((solution, index) => (
            <div
              key={solution.id}
              className={`group relative transition-all duration-700 transform ${
                isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
              onClick={() => setSelectedSolution(solution)}
            >
              <div className="relative bg-white rounded-3xl p-8 h-full border border-gray-200 shadow-lg hover:shadow-2xl transition-all duration-500 group-hover:scale-105 cursor-pointer overflow-hidden">
                
                {/* Category Badge */}
                <div className={`absolute top-4 right-4 px-3 py-1 rounded-full bg-gradient-to-r ${solution.color} text-white text-xs font-semibold`}>
                  {solution.category}
                </div>

                {/* Gradient Overlay */}
                <div className={`absolute inset-0 bg-gradient-to-br ${solution.color} opacity-0 group-hover:opacity-5 transition-opacity duration-500`}></div>
                
                <div className="relative z-10">
                  {/* Icon */}
                  <div className={`p-4 rounded-2xl bg-gradient-to-r ${solution.color} shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-110 inline-block mb-6`}>
                    <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      {solution.icon}
                    </svg>
                  </div>

                  {/* Title */}
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 leading-tight">
                    {solution.title}
                  </h3>
                  
                  {/* Description */}
                  <p className="text-gray-600 leading-relaxed mb-6">
                    {solution.description}
                  </p>

                  {/* Key Solutions Preview */}
                  <div className="space-y-2 mb-6">
                    <p className="text-sm font-semibold text-gray-900 mb-3">Key Solutions:</p>
                    {solution.solutions.slice(0, 3).map((item, idx) => (
                      <div key={idx} className="flex items-center text-gray-600">
                        <div className={`w-1.5 h-1.5 rounded-full bg-gradient-to-r ${solution.color} mr-3`}></div>
                        <span className="text-sm">{item}</span>
                      </div>
                    ))}
                    {solution.solutions.length > 3 && (
                      <p className="text-sm text-indigo-600 font-medium ml-5">
                        +{solution.solutions.length - 3} more
                      </p>
                    )}
                  </div>

                  {/* Pricing */}
                  <div className="pt-4 border-t border-gray-200">
                    <p className="text-sm text-gray-500 mb-1">Starting at</p>
                    <p className="text-lg font-bold text-gray-900">{solution.pricing}</p>
                  </div>

                  {/* Learn More Arrow */}
                  <div className="absolute bottom-8 right-8 opacity-0 group-hover:opacity-100 transform translate-x-4 group-hover:translate-x-0 transition-all duration-500">
                    <div className={`p-2 rounded-full bg-gradient-to-r ${solution.color} text-white`}>
                      <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Glow Effect */}
                <div className={`absolute -inset-1 bg-gradient-to-r ${solution.color} rounded-3xl blur opacity-0 group-hover:opacity-20 transition-opacity duration-500 -z-10`}></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Solution Detail Modal */}
      {selectedSolution && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setSelectedSolution(null)}>
          <div className="bg-white rounded-3xl max-w-5xl w-full max-h-[90vh] overflow-y-auto p-8 relative" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => setSelectedSolution(null)}
              className="absolute top-6 right-6 p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors z-10"
            >
              <svg className="h-6 w-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <div className={`inline-flex items-center px-3 py-1 rounded-full bg-gradient-to-r ${selectedSolution.color} text-white text-sm font-semibold mb-4`}>
              {selectedSolution.category}
            </div>

            <div className={`p-4 rounded-2xl bg-gradient-to-r ${selectedSolution.color} shadow-lg inline-block mb-6`}>
              <svg className="h-10 w-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {selectedSolution.icon}
              </svg>
            </div>

            <h2 className="text-4xl font-bold text-gray-900 mb-6">{selectedSolution.title}</h2>
            
            <p className="text-gray-600 text-lg leading-relaxed mb-8">{selectedSolution.description}</p>

            <div className="grid md:grid-cols-2 gap-8 mb-8">
              {/* Challenges */}
              <div className="bg-red-50 rounded-2xl p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <svg className="h-6 w-6 text-red-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                  Common Challenges
                </h3>
                <div className="space-y-3">
                  {selectedSolution.challenges.map((challenge, idx) => (
                    <div key={idx} className="flex items-start">
                      <div className="w-2 h-2 rounded-full bg-red-500 mr-3 mt-2"></div>
                      <span className="text-gray-700">{challenge}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Solutions */}
              <div className="bg-green-50 rounded-2xl p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <svg className="h-6 w-6 text-green-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Our Solutions
                </h3>
                <div className="space-y-3">
                  {selectedSolution.solutions.map((item, idx) => (
                    <div key={idx} className="flex items-start">
                      <div className={`w-6 h-6 rounded-full bg-gradient-to-r ${selectedSolution.color} flex items-center justify-center mr-3 flex-shrink-0`}>
                        <svg className="h-4 w-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <span className="text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Results */}
            <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl p-6 mb-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                <svg className="h-6 w-6 text-indigo-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
                Expected Results
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {selectedSolution.results.map((result, idx) => (
                  <div key={idx} className="flex items-center bg-white rounded-xl p-4">
                    <div className={`w-3 h-3 rounded-full bg-gradient-to-r ${selectedSolution.color} mr-3`}></div>
                    <span className="text-gray-700 font-medium">{result}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Industries */}
            <div className="mb-8">
              <h3 className="text-lg font-bold text-gray-900 mb-3">Perfect for:</h3>
              <div className="flex flex-wrap gap-2">
                {selectedSolution.industries.map((industry, idx) => (
                  <span key={idx} className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium">
                    {industry}
                  </span>
                ))}
              </div>
            </div>

            {/* Pricing & CTA */}
            <div className={`bg-gradient-to-r ${selectedSolution.color} rounded-2xl p-6 text-white`}>
              <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                <div>
                  <p className="text-sm opacity-90 mb-1">Investment</p>
                  <p className="text-3xl font-bold">{selectedSolution.pricing}</p>
                </div>
                <button className="bg-white text-gray-900 px-8 py-4 rounded-xl font-semibold hover:shadow-lg transition-all duration-300 transform hover:scale-105">
                  Schedule Consultation
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CTA Section */}
      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 py-20">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="text-4xl font-bold text-white mb-6">
            Not Sure Which Solution Fits Your Business?
          </h2>
          <p className="text-xl text-indigo-100 mb-8">
            Let our experts analyze your business and recommend the perfect solution tailored to your goals.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-indigo-600 px-8 py-4 rounded-xl font-semibold hover:shadow-2xl transition-all duration-300 transform hover:scale-105">
              Get Free Consultation
            </button>
            <button className="border-2 border-white text-white px-8 py-4 rounded-xl font-semibold hover:bg-white hover:text-indigo-600 transition-all duration-300 transform hover:scale-105">
              View Success Stories
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SolutionsPage;
